export default __webpack_public_path__ + "static/media/LANDING4.8b1b12f4.jpg";